import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import Breakpoints from 'lib/Breakpoints';

import Related from 'components/Related';
import GiftGuide from 'components/GiftGuide';

const mapStateToProps = (state) => {
  const taxonomy = get(state, 'article.content[0].taxonomy');
  const articleID = get(state, 'article.content[0].id');
  return {
    taxonomy,
    articleID,
  };
};

class Recommended extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    isGiftGuide: PropTypes.bool,
    isNBCNewsCommerce: PropTypes.bool,
    isBetterNewsCommerce: PropTypes.bool,
    isRightRail: PropTypes.bool,
    isTrending: PropTypes.bool,
    mobile: PropTypes.bool,
    taxonomy: PropTypes.shape({
      primarySection: PropTypes.shape({
        id: PropTypes.string,
      }),
      primaryTopic: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    articleID: PropTypes.string,
  };

  static defaultProps = {
    additionalClasses: '',
    isGiftGuide: false,
    isNBCNewsCommerce: false,
    isBetterNewsCommerce: false,
    isRightRail: false,
    isTrending: false,
    mobile: true,
    taxonomy: {},
    articleID: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      formattedRecommendationItems: [],
    };
  }

  componentDidMount() {
    const { articleID, taxonomy } = this.props;
    const taxonomyPrimaryTopicName = get(taxonomy, ['primaryTopic', 'name']);
    const items = get(taxonomy, ['primaryTopic', 'content', 'items'], []);
    const itemLimit = this.getLimit();
    let itemCount = 0;
    const formatRecommendedItems = (resolved, item) => {
      const { taxonomy: itemTaxonomy, type, id } = item;
      const relatedItemPrimaryTopicName = get(itemTaxonomy, ['primaryTopic', 'name']);

      if (
        itemCount >= itemLimit
        || !id // A recommended article without an ID is likely invalid, and can be skipped
        || taxonomyPrimaryTopicName !== relatedItemPrimaryTopicName
        || articleID === id
      ) return resolved;

      const thumbnail = get(item, ['primaryImage', 'url', 'primary']);
      const unibrow = {
        url: get(item, ['unibrow', 'url']),
        text: get(item, ['unibrow', 'text']),
      };
      const title = get(item, ['headline', 'tease']);
      const url = get(item, ['url', 'primary']);
      const resolvedItem = {
        id,
        url,
        type,
        title,
        unibrow,
        thumbnail,
      };

      resolved.push(resolvedItem);
      itemCount += 1;

      return resolved;
    };

    const formattedRecommendationItems = items.reduce(formatRecommendedItems, []);

    this.setState({ formattedRecommendationItems });
  }

  getType = () => {
    const {
      isGiftGuide,
      isTrending,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
    } = this.props;
    if (isTrending && !isBetterNewsCommerce) {
      return 'trending';
    }
    if (isGiftGuide) {
      return 'giftGuide';
    }
    if (isNBCNewsCommerce) {
      return 'nbcNewsCommerce';
    }
    if (isBetterNewsCommerce) {
      return 'betterNewsCommerce';
    }
    return 'article';
  }

  getLimit = () => {
    const { isGiftGuide, isTrending, isNBCNewsCommerce } = this.props;

    if (isNBCNewsCommerce || isTrending || isGiftGuide) {
      return 4;
    }

    return Breakpoints.isS() ? 1 : 2;
  }

  shouldShow = () => {
    const {
      mobile,
      isTrending,
      isGiftGuide,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
    } = this.props;
    if (isTrending || isGiftGuide || isNBCNewsCommerce || isBetterNewsCommerce) {
      return true;
    }
    return (mobile && Breakpoints.isSorM()) || (!mobile && Breakpoints.isLorXL());
  }

  render() {
    const {
      additionalClasses,
      isGiftGuide,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
      isRightRail,
      isTrending,
    } = this.props;
    const { formattedRecommendationItems = [] } = this.state;

    // No results, return early
    if (!formattedRecommendationItems.length) {
      return null;
    }

    const title = isTrending ? i18next.t('Trending') : i18next.t('Recommended');
    const id = title.toLowerCase();

    let linkTrackingID;
    if (isTrending || isNBCNewsCommerce) {
      linkTrackingID = 'recommended_shop';
    } else {
      linkTrackingID = id;
    }

    if (isGiftGuide) {
      return (
        <GiftGuide
          items={formattedRecommendationItems}
          data-test="gift-guide"
        />
      );
    }

    if (this.shouldShow()) {
      return (
        <Related
          additionalClasses={additionalClasses}
          elementId={id}
          isNBCNewsCommerce={isNBCNewsCommerce}
          isBetterNewsCommerce={isBetterNewsCommerce}
          isRightRail={isRightRail}
          isTrending={isTrending}
          items={formattedRecommendationItems}
          linkTracking={linkTrackingID}
          title={title}
        />
      );
    }

    return null;
  }
}

export default connect(mapStateToProps)(Recommended);
